import colorPalette from '../color-palette';

const { primary } = colorPalette;

export default {
  MuiTab: {
    root: {
      color: primary.main,
    },
    textColorInherit: {
      color: primary.main,
      opacity: 1,
    },
    wrapped: {
      height: '100%',
      display: 'block',
    },
  },
};
